import { ApiError } from '@/shared/api/client';
import type { TextLoadItem, TextLoadKind } from '@/shared/api/resources';

/**
 * Os itens recusados na carga, lidos de `details.items` da recusa (422): a posicao, o
 * tipo, o alvo e as mensagens. Sem eles a pessoa le "A carga foi recusada" sem saber
 * qual item falhou (R5-B12 da revisao 5).
 */
export function itensRecusados(erro: unknown): TextLoadItem[] {
  if (!(erro instanceof ApiError)) return [];
  const itens = erro.details?.items;
  if (!Array.isArray(itens)) return [];
  return itens.flatMap((bruto: unknown): TextLoadItem[] => {
    if (typeof bruto !== 'object' || bruto === null) return [];
    const item = bruto as Record<string, unknown>;
    if (typeof item.position !== 'number') return [];
    const mensagens = Array.isArray(item.messages) ? item.messages : [];
    return [
      {
        position: item.position,
        kind: (typeof item.kind === 'string' ? item.kind : '') as TextLoadKind,
        target: typeof item.target === 'string' ? item.target : '',
        result: 'erro',
        messages: mensagens.filter(
          (mensagem): mensagem is string => typeof mensagem === 'string',
        ),
        modality_id: null,
        coverage_id: null,
        template_id: null,
        version: null,
        body_sha256: '',
        body_characters: 0,
      },
    ];
  });
}
